import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { format, parse } from "date-fns";
@Injectable({
  providedIn: "root",
})
export class Util {
  dateToSql(date: string): string | null {
    if (date == null || typeof date === "undefined" || date === "") {
      return null;
    }
    const dateParse = parse(date, "dd/MM/yyyy", new Date());
    return format(dateParse, "yyyy-MM-dd");
  }

  dateToDateOnlyString(date: Date) : string | null {
    if (date == null || typeof date === "undefined") {
      return null;
    }
    return format(date, "yyyy-MM-dd");
  }

  formatDate(isoDate: string): string {
    const date = new Date(isoDate);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

  formatDateBirthday(isoDate: any): string {
    const date = new Date(isoDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}`;
  }

  convertCurrencyToBRL(currency: any) {
    return Number(currency).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  /**
   * check is valid date
   * @param dateString in format ddMMyyyy
   * @returns true or false
   */
  isValidDate(dateString: string): boolean {

    const regex = /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])(19|20)\d\d$/; // ddMMyyyy

    if (dateString == null || typeof dateString === "undefined") return true;
    if (!dateString.match(regex)) return false; // Verifica se o formato está correto

    const day = parseInt(dateString.substring(0, 2), 10);
    const month = parseInt(dateString.substring(2, 4), 10);
    const year = parseInt(dateString.substring(4, 8), 10);
    const date = new Date(year, month - 1, day);

    // Verifica se a data criada é a mesma que a data informada
    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  }

  maskCnpj(cnpj: string) {
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  cnpjValidator(control: AbstractControl): ValidationErrors | null {
    const cnpj = control.value;

    if (!cnpj) {
      return null;
    }

    // Remove caracteres não numéricos
    const cleanedCnpj = cnpj.replace(/[^\d]+/g, '');

    if (cleanedCnpj.length !== 14) {
      return { invalidCnpj: true };
    }

    // Validação do CNPJ
    let length = cleanedCnpj.length - 2;
    let numbers = cleanedCnpj.substring(0, length);
    const digits = cleanedCnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i)) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(digits.charAt(0))) {
      return { invalidCnpj: true };
    }

    length = length + 1;
    numbers = cleanedCnpj.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i)) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(digits.charAt(1))) {
      return { invalidCnpj: true };
    }

    return null;
  }

  alphabeticalOrder(object: any, key: string) {
    return object.sort((a: any, b: any) => {
      return a[`${key}`].localeCompare(b[`${key}`]);
    });
  }
}
